import React, { useEffect, useState } from 'react';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import VideoPlayer from '../../../components/jsx/learnings/StudyMaterial/materialType/Video';

const MaterialDetailPage = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const materialId = searchParams.get('id');
  const materialType = searchParams.get('type');
  
  const [materialData, setMaterialData] = useState(null);

  useEffect(() => {
    // Check if data is passed via location state
    if (location.state && location.state.videoData) {
      setMaterialData(location.state.videoData);
    } else {
      // If no data is passed, could fetch it from API using materialId
      // For now, redirect back to materials page if no data
      navigate('/learning/materials');
    }
  }, [location, materialId, navigate]);

  // Show loading state if material data is not available yet
  if (!materialData) {
    return <div className="p-8 text-center">Loading material data...</div>;
  }

  // Render appropriate component based on material type
  const renderMaterial = () => {
    switch (materialType) {
      case 'video':
        return (
          <VideoPlayer 
            videoUrl={materialData.videoUrl}
            title={materialData.title} 
            description={materialData.description}
          />
        );
      // Add cases for other material types here
      default:
        return <div>Unsupported material type</div>;
    }
  };

  return (
    <div className="">
      {renderMaterial()}
    </div>
  );
};

export default MaterialDetailPage;